// extracted by mini-css-extract-plugin
export default {"options":"Options_options__dSFIj","searchBar":"Options_searchBar__2L+lk","search":"Options_search__3mrf5","buttons":"Options_buttons__w4bHn"};